import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import * as c3 from 'c3';
import { PrimitiveArray } from 'c3';

@Component({
  selector: 'pl-gauge-chart',
  templateUrl: './gaugeChart.component.html',
  styleUrls: ['./gaugeChart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GaugeChartComponent implements AfterViewInit {
  @Input() public max: number = 100;
  @Input() public min: number = 0;
  @Input() public suffixLabel: string = '';
  @Input() public title: string = '';
  @Input({ required: true }) public color!: string;
  @Input({ required: true }) public value!: number;

  @ViewChild('chartContainer', { static: true }) public chartContainer!: ElementRef;

  private readonly DATA_COLUMN_DEF: string = 'pl-data' as const;

  public ngAfterViewInit(): void {
    const suffixLabel: string = this.suffixLabel;
    c3.generate({
      bindto: this.chartContainer.nativeElement,
      color: {
        pattern: [this.color],
      },
      data: {
        columns: this.getColumnsDefinition(),
        type: 'gauge',
      },
      gauge: {
        label: {
          format: function (value: number): string {
            const valueRoundedAsString: string = `${Math.round(value)}`;
            if (suffixLabel) {
              return `${valueRoundedAsString} ${suffixLabel}`;
            }
            return valueRoundedAsString;
          },
          show: true, // to turn off the min/max labels.
        },
        max: this.max,
        min: this.min,
      },

      legend: {
        show: false,
      },
      tooltip: {
        show: false,
      },
    });
  }

  private getColumnsDefinition(): [string, ...PrimitiveArray][] {
    return [[this.DATA_COLUMN_DEF, this.value]];
  }
}
